import { useState, useEffect } from "react";
import { navbarLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, "#hero")}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <i className="ri-fire-line text-background-50 text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-bold whitespace-nowrap transition-colors ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
            51吃瓜网站
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navbarLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            scrolled ? "text-foreground-700 hover:bg-background-100" : "text-background-50 hover:bg-white/10"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4 pt-2 shadow-lg">
          {navbarLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="block py-3 px-4 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg cursor-pointer transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}